import React, { useState, useEffect } from "react";
import Table from "../../../component/table";
import Select from "react-select";
import { useFormik, FieldArray, FormikProvider, Form } from "formik";
import { useNavigate, useLocation } from "react-router-dom";
import {
  RESET_SAVE_TEMPORARY_DATA,
  SET_RETAIN_PROPS,
  SET_TODO_NOTIFICATION_DATA,
} from "../../../redux/constants";
import { useDispatch, useSelector } from "react-redux";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../../component/modal-popup/customeModal";
import {
  getToDoNotificationData,
  addToDoNotification,
} from "../../../redux/actions/todo";
import SideModal from "../../../component/SideModal";
import EmailComposer from "./EmailComposer";

function NotificationManagement({ setStep }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;

  // Redux
  const dispatch = useDispatch();
  const { tempPageName, saveData } = useSelector((state) => state.tempWindowsData);
  const { newtododata, todoNotificationData, parentToDoIdForCopy } = useSelector(
    (state) => state.todo
  );

  const [activeModal, setActiveModal] = useState(false);
  const [activeNotification, setActiveNotification] = useState(null);
  const [isSaved, setIsSaved] = useState(false);

  const todo_id = state ? state.id : newtododata;

  const defaultTodoNotificationRule = {
    trigger: {
      label: "Pending",
      value: "pending",
    },
    stakeholder: {
      label: "Assigned User",
      value: "assignee",
    },
    is_active: true,
    is_data_filled: true,
    edit: false,
  };

  // State
  const [deletedNotifications, setDeletedNotifications] = useState([]);

  const [notificationFormik, setNotificationFormik] = useState([]);
  // {
  //   todo_id: state ? state.id : newtododata,
  //   ...defaultTodoNotificationRule,
  // },

  // Constants
  const todoStatusOption = state?.master_activity?.is_immutable
    ? [
        {
          label: "Pending",
          value: "pending",
        },
        {
          label: "In Progress",
          value: "in progress",
        },

        {
          label: "Completed",
          value: "completed",
        },
      ]
    : [
        {
          label: "Pending",
          value: "pending",
        },
        {
          label: "In Progress",
          value: "in progress",
        },
        {
          label: "Overdue",
          value: "overdue",
        },
        {
          label: "Completed",
          value: "completed",
        },
        {
          label: "Unlocked",
          value: "unlocked",
        },
      ];
  const notify_stakeholder_option = [
    {
      label: "Assigning User",
      value: "assigner",
    },
    {
      label: "Assigned User",
      value: "assignee",
    },
    {
      label: "Super-Admin",
      value: "super-admin",
    },
    {
      label: "Customer",
      value: "customer",
    },
  ];

  // Formik
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      notificationConfig: notificationFormik,
    },
    onSubmit: (value) => {
      handleNotificationSubmit();
    },
  });

  // Function to call post API to add Notification data
  const handleNotificationSubmit = () => {
    setIsSaved(true);
    const todoNotificationPayload = formik.values.notificationConfig
      // .filter((item) => item.trigger && item.stakeholder && item.is_data_filled)
      .filter((item) => ((item.trigger?.value === 'send email' && !item.stakeholder) || (item.trigger && item.stakeholder)) && item.is_data_filled)
      .map((element) => {
        if (element) {
          let obj = {
            todo_id: newtododata ? newtododata : element.todo_id,
            trigger: element?.trigger?.value,
            stakeholder: element?.stakeholder?.value,
            is_active: element.is_active,
          }

          if(element?.attach_booking_documents) obj['attach_booking_documents'] = element?.attach_booking_documents;
          if(element?.attach_todo_documents) obj['attach_todo_documents'] = element?.attach_todo_documents;
          if(element?.body) obj['body'] = element?.body;
          if(element?.body_obj) {
            obj['body_obj'] =  typeof element?.body_obj === "string" ? JSON.parse(element.body_obj) : [
            ...new Map(element?.body_obj?.map((item) => [JSON.stringify(item), item])).values()
          ];}
          if(element?.subject) obj['subject'] = element?.subject?.trim();
          if(element?.subject_obj) {
            obj['subject_obj'] = typeof element?.subject_obj === "string" ? JSON.parse(element.subject_obj) : [
            ...new Map(element?.subject_obj?.map((item) => [JSON.stringify(item), item])).values()
          ]}
          if(element?.use_custom_notification) obj['use_custom_notification'] = element?.use_custom_notification;
          if (element?.notification_id) {
            obj.notification_id = element.notification_id;
          }
          return obj;
        }
        return [];
      });

    const request = {
      payload: {
        deleted_notification: deletedNotifications,
        notification: todoNotificationPayload,
      },
      onSuccess: () => {
        setStep(3);
        navigate("/activity/overview");
        setIsSaved(false);
      },
      onError: (error) => {
        if (error?.message === "Duplicate entry") {
          swal({
            content: (
              <CustomeModal
                type="error"
                title="Error!"
                content={"Please remove duplicate notification rules."}
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        } else {
          swal({
            content: (
              <CustomeModal
                type="error"
                title="Error!"
                content={"Something went wrong, please try again later."}
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        }
        setIsSaved(false);
      },
    };

    dispatch(addToDoNotification(request));
    if (tempPageName === "manage todo") {
      dispatch({ type: RESET_SAVE_TEMPORARY_DATA });
    }
  };

  // Function to show delete modal pop-up
  const deleteModalPopUp = (index, arrayHelpers, notification_id) => {
    swal({
      content: (
        <CustomeModal
          type="delete"
          title="Are you sure?"
          content="All of your data will be permanently removed from our servers forever. This action cannot be undone."
          onDelete={() => {
            arrayHelpers.remove(index);
            if (setDeletedNotifications) {
              if (notification_id) {
                setDeletedNotifications([
                  ...deletedNotifications,
                  notification_id,
                ]);
              }
            }
          }}
          onCancel={() => {}}
        />
      ),
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
    });
  };

  useEffect(() => {
    const request = {
      todo_id: parentToDoIdForCopy ? parentToDoIdForCopy : state ? state.id : newtododata,
      onError: (error) => {
        swal({
          content: <CustomeModal type="error" title="Error!" content={error} />,
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };

    dispatch(getToDoNotificationData(request));

    return () => {
      dispatch({ type: SET_TODO_NOTIFICATION_DATA, payload: [] });
    };
  }, [dispatch, newtododata, state]);

  // useEffect to set notificationFormik data
  useEffect(() => {
    if (todoNotificationData.length > 0) {
      const filteredNotificationData = todoNotificationData.map((item) => {
        let triggerValue = todoStatusOption.find(
          (element) => element.value === item.trigger
        )

        if(!triggerValue && item.trigger === "send email"){
          triggerValue = { value: "send email" }
        }

        const filteredObject = {
          todo_id: item.todo_id,
          trigger: triggerValue,
          stakeholder: [
            ...notify_stakeholder_option,
            {
              label: "Assigned User (Next To Do)",
              value: "next_todo_assigned_user",
            },
          ].find((element) => element.value === item.stakeholder),
          is_active: item.is_active,
          is_data_filled: true,
          notification_id: item.notification_id,
          edit: false,
          use_custom_notification: item.use_custom_notification,
          subject: item.subject,
          subject_obj: item.subject_obj,
          body: item.body,
          body_obj: item.body_obj,
          attach_booking_documents: item.attach_booking_documents,
          attach_todo_documents: item.attach_todo_documents
        };


        return filteredObject;
      });
      setNotificationFormik(filteredNotificationData);
    } else if(todoNotificationData.length === 0 && newtododata){
      setNotificationFormik([
        {
          todo_id: newtododata,
          ...defaultTodoNotificationRule,
        },
      ])
    }
  }, [todoNotificationData]);

  const getSubTitle = (index) => {
    let title = ``;
    const data = formik.values.notificationConfig[index];
    if(data && data.trigger?.value !== "send email" ){
      title = `
        Notify <span class="text-[--bg-color-500]">${data.stakeholder.label}</span> when <span class="text-[--bg-color-500]">${data.trigger.label}</span>
      `
    }

    return title;
  }

  const handleEmailComposerSubmit = (data) => {
    const notificationData = {
      ...formik.values.notificationConfig[activeNotification],
      ...data
    }
    formik.setFieldValue(`notificationConfig[${activeNotification}]`, notificationData)
  }

  return (
    <div
      className="relative py-4 h-screen space-y-4"
      style={{ maxHeight: "calc(100vh - 150px)" }}
    >
      <div className="h-full space-y-3">
        <div className="rounded-md bg-[--bg-color-50] p-5 space-y-2">
          <h4 className="text-base font-bold leading-5 text-[#535860]">
            Notification Rules
          </h4>
          <div
            className="h-screen overflow-y-auto overflow-x-auto scrollbar scrollbar-w-1 scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar-thumb-gray-300 scrollbar-track-gray-100"
            style={{ maxHeight: "calc(100vh - 450px)", minHeight: "auto" }}
          >
            <FormikProvider value={formik}>
              <Form autoComplete="off" noValidate>
                <FieldArray
                  name="notificationConfig"
                  render={(arrayHelpers) => (
                    <>
                      <Table
                        heads={[
                          {
                            headName: "To Do Status",
                            isSort: false,
                            value: "To Do Status",
                          },
                          {
                            headName: "Notify Stakeholder",
                            isSort: false,
                            value: "To Do",
                          },
                          {
                            headName: "Template Used",
                            isSort: false,
                            value: "Template Used",
                          },
                          { headName: "", isSort: false, value: "", class: "w-[200px]" },
                        ]}
                        tClass="table-fixed w-full border-separate border-spacing-y-2"
                        hClass="text-[15px] leading-2 tracking-tight font-bold text-[#535860] bg-white sticky top-0"
                        bClass="text-sm"
                        thClass="px-2 py-3 whitespace-nowrap text-left last:text-center font-semibold first:pl-4 first:rounded-l-md last:rounded-r-md max-w-1/4 sticky top-0"
                      >
                        {formik.values.notificationConfig.map((item, index) => {   
                          return (
                            <>
                              {(item.trigger?.value !== "send email") && (
                                <tr className={`${ activeNotification === index && activeModal ? "bg-[--bg-color-500]" : "bg-white"} cursor-pointer`} key={index}>
                                  <td className="px-2 py-2 text-sm leading-4 tracking-tight first:pl-4 text-[#1E293B] rounded-l-md max-w-1/4 truncate space-x-4">
                                    {item.is_data_filled && !item.edit ? (
                                        <div className={`${ activeNotification === index && activeModal  && "text-white"}`}
                                          onClick={() => {
                                            setActiveNotification(index);
                                            setActiveModal(true);
                                          }}
                                        >
                                          {item.trigger.label}
                                        </div>
                                    ) : (
                                      <Select
                                        placeholder="Select Status"
                                        isClearable={true}
                                        value={item.trigger} 
                                        options={todoStatusOption}
                                        menuPortalTarget={document.body}
                                        className="unresetText"
                                        onChange={(element) => {
                                          formik.setFieldValue(
                                            `notificationConfig[${index}].trigger`,
                                            element
                                          );
                                        }}
                                      />
                                    )}
                                  </td>
                                  <td className="px-2 py-2 text-sm leading-4 tracking-tight first:pl-4 text-[#1E293B] text-left max-w-1/4 truncate space-x-4">
                                    {item.is_data_filled && !item.edit ? (
                                      <div className={`${ activeNotification === index && activeModal  && "text-white"}`}
                                        onClick={() => {
                                          setActiveNotification(index);
                                          setActiveModal(true);
                                        }}
                                      >
                                        {item.stakeholder?.label}
                                      </div>
                                    ) : (
                                      <Select
                                        value={item.stakeholder}
                                        options={
                                          item?.trigger?.value === "completed"
                                            ? [
                                                ...notify_stakeholder_option,
                                                {
                                                  label: "Assigned User (Next To Do)",
                                                  value: "next_todo_assigned_user",
                                                },
                                              ]
                                            : notify_stakeholder_option
                                        }
                                        placeholder="Select Notify Stakeholder"
                                        isClearable={true}
                                        menuPortalTarget={document.body}
                                        className="unresetText"
                                        onChange={(element) =>
                                          formik.setFieldValue(
                                            `notificationConfig[${index}].stakeholder`,
                                            element
                                          )
                                        }
                                      />
                                    )}
                                  </td>
                                  <td className="px-2 py-2 text-sm leading-4 tracking-tight first:pl-4 text-[#1E293B] max-w-1/4 truncate space-x-4">
                                    {
                                      item.is_data_filled && !item.edit ? (
                                      <div className={`${ activeNotification === index && activeModal  && "text-white"}`}
                                        onClick={() => {
                                          setActiveNotification(index);
                                          setActiveModal(true);
                                        }}
                                      >
                                        { item.use_custom_notification ? "Custom Template" : "Shiperone Default Template"}
                                      </div>
                                      ) : ""
                                    }
                                  </td>
                                  <td className="pl-2 pr-4 py-2 text-sm leading-4 tracking-tight first:pl-4 text-right text-[#1E293B] rounded-r-md max-w-1/4 truncate space-x-4">
                                    {item.is_data_filled && !item.edit ? (
                                      <div >
                                        <div className="flex items-center justify-end space-x-3">
                                          <h6
                                            className={`text-xs text-[#AEAEAE] tracking-tight leading-3`}
                                          >
                                            Active
                                          </h6>
                                          <div className={`form-switch`}>
                                            <input
                                              id={`toggle-${index}`}
                                              type="checkbox"
                                              name="toogle"
                                              checked={item.is_active}
                                              onChange={(e) =>
                                                formik.setFieldValue(
                                                  `notificationConfig[${index}].is_active`,
                                                  e.target.checked
                                                )
                                              }
                                              className={`sr-only`}
                                            />
                                            <label
                                              htmlFor={`toggle-${index}`}
                                              className={`bg-slate-400`}
                                            >
                                              <span
                                                className={`bg-white shadow-sm`}
                                                aria-hidden="true"
                                              ></span>
                                            </label>
                                          </div>
                                          {/* <span
                                            className="fa-light fa-pen text-base cursor-pointer"
                                            style={{ color: "#9297a2" }}
                                            onClick={() => {
                                              if(editLength === 0){
                                                formik.setFieldValue(
                                                  `notificationConfig[${index}].edit`,
                                                  true
                                                )
                                              }
                                            }}
                                          /> */}
                                          <span
                                            title="Email Composer"
                                            className={`fa-light ${item?.subject && item.use_custom_notification ? "fa-square-pen" : "fa-square-plus"} text-base cursor-pointer`}
                                            style={{ color: "#9297a2" }}
                                            onClick={() => {
                                              setActiveNotification(index);
                                              setActiveModal(true);
                                            }}
                                          />
                                          <span
                                            title="Delete"
                                            className="fa-light fa-trash-can text-base cursor-pointer text-rose-500"
                                            onClick={() => {
                                              deleteModalPopUp(
                                                index,
                                                arrayHelpers,
                                                item?.notification_id
                                              );
                                            }}
                                          />

                                        </div>
                                        
                                      </div>
                                    ) : (
                                      <>
                                        <button
                                          type="button"
                                          className="btn !bg-[--bg-color-500] text-white hover:bg-gray-50 "
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            if (item.stakeholder && item.trigger) {
                                              formik.setFieldValue(
                                                `notificationConfig[${index}].is_data_filled`,
                                                true
                                              );
                                              formik.setFieldValue(
                                                `notificationConfig[${index}].edit`,
                                                false
                                              );
                                            }
                                          }}
                                        >
                                          { !item.edit ? "Add" : "Update" }
                                        </button>
                                        <span
                                          title="Delete"
                                          className="fa-light fa-trash-can text-base cursor-pointer text-rose-500"
                                          onClick={() => {
                                            deleteModalPopUp(
                                              index,
                                              arrayHelpers,
                                              item?.notification_id
                                            );
                                          }}
                                        />
                                      </>
                                    )}
                                  </td>
                                </tr>
                              )}
                            </>
                            
                          );
                        })}
                      </Table>
                      {formik.values.notificationConfig?.filter(
                        (item) => !item.is_data_filled
                      ).length === 0 && (
                        <h6
                          className={`text-xs font-semibold leading-3 tracking-tight text-[--bg-color-500] cursor-pointer my-2`}
                          onClick={() =>{
                            const dataValues= {
                              temp_id: Math.random(),
                              todo_id: state ? state.id : newtododata,
                              trigger: "",
                              stakeholder: "",
                              is_active: true,
                              is_data_filled: false,
                            }
                            arrayHelpers.push(dataValues);
                          }
                          }
                        >
                          + Add Item
                        </h6>
                      )}
                    </>
                  )}
                />
              </Form>
            </FormikProvider>
          </div>
        </div>
        {/* h-[25%] lg:h-[20%]  */}
        <div className="rounded-md bg-[--bg-color-50] p-5 space-y-2 overflow-y-auto scrollbar scrollbar-w-1 scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar-thumb-gray-300 scrollbar-track-gray-100"
        >
          <h4 className="text-base font-bold leading-5 text-[#535860] mb-4">
            Send As Email Button
          </h4>
          <div className="w-[380px] px-5 py-4 bg-white rounded-lg ">
            <div className="font-inter font-semibold text-base text-[--bg-color-500] cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setActiveModal(true);

                let sendMailIndex = formik.values.notificationConfig.findIndex(item => item.trigger?.value === "send email");

                if(sendMailIndex === -1){
                  const dataValues= {
                    temp_id: Math.random(),
                    todo_id: state ? state.id : newtododata,
                    trigger: { value: "send email" },
                    stakeholder: "",
                    is_active: true,
                    is_data_filled: true,
                  }
                  sendMailIndex = formik.values.notificationConfig.length;
                  formik.values.notificationConfig.push(dataValues)
                  // formik.setFieldValue("notificationConfig", [...formik.values.notificationConfig, dataValues]);
                }
                setActiveNotification(sendMailIndex);
              }}
            >Edit Notification Template of “Send as Email”</div>
          </div>
        </div>
      </div>
      <div
        className={`absolute bottom-0 w-full flex item-center justify-between`}
      >
        <button
          className="btn bg-white border-slate-200 hover:border-slate-300 text-slate-600 cursor-pointer"
          onClick={() => {
            if (tempPageName === "manage todo") {
              dispatch({ type: RESET_SAVE_TEMPORARY_DATA });
            }
            dispatch({ type: SET_RETAIN_PROPS, payload: false });
            navigate("/activity/overview");
          }}
        >
          Cancel
        </button>

        <div className="space-x-4">
          <button
            className="btn bg-white border-slate-200 hover:border-slate-300 text-slate-600 cursor-pointer"
            onClick={() => {
              if (tempPageName === "manage todo") {
                dispatch({ type: RESET_SAVE_TEMPORARY_DATA });
              }
              setStep(2)
            }}
          >
            Back
          </button>
          <button
            type="submit"
            className={`btn ${isSaved ? "!bg-[--bg-color-400] cursor-not-allowed" : "!bg-[--bg-color-500] cursor-pointer"}  !hover:bg-[--bg-color-600] text-white `}
            onClick={() => formik.handleSubmit()}
            disabled={isSaved}
          >
            Save
          </button>
        </div>
      </div>
      <SideModal isOpen={activeModal} setIsOpen={setActiveModal} title={"Notification Template"} subtitle={getSubTitle(activeNotification)} >
        <EmailComposer isOpen={activeModal} setIsOpen={setActiveModal} todo_id={todo_id} _handleSubmit={handleEmailComposerSubmit} emailData={formik.values.notificationConfig[activeNotification]} />
      </SideModal>
    </div>
  );
}

export default NotificationManagement;
